import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Flex } from '@theme-ui/components';
import { css } from '@emotion/react';

import { Button } from '@app/components/Button';
import LoginLink from '@app/components/LoginLink';
import { H3 } from '@app/components/typography';

import messages from './WhatsNewForMe.messages';

const Guest = () => {
  const [isRedirecting, setIsRedirecting] = useState(false);

  return (
    <Flex
      sx={{ alignItems: 'center', flexDirection: 'column' }}
      data-testid="whats-new-for-me-guest"
      mb={4}
    >
      <Box mb={4}>
        <H3
          css={css`
            text-transform: none;
            margin-top: 0;
          `}
        >
          <FormattedMessage {...messages.ownPrevious} />
        </H3>
      </Box>
      <Box mb={4}>
        <LoginLink>
          <Button
            data-testid="whats-new-for-me-login-button"
            onClick={() => setIsRedirecting(true)}
            isLoading={isRedirecting}
            type="primary"
          >
            <FormattedMessage {...messages.ownPreviousButton} />
          </Button>
        </LoginLink>
      </Box>
    </Flex>
  );
};

export default Guest;
